export default __webpack_public_path__ + "static/hexagon-ec327d457f45f79d1585d034d3d55152.png";